import React from "react";
import { Link } from "react-router-dom";
import appvideo from "../logos/appvideo.mp4";

function About() {
  return (
    <div className="about">
      <div className="news-feed">
        <h3>News Feed</h3>
        <div className="news">
          <div>
            <p>
              How Amazon Robotics is working to eliminate the need of barcodes.
              Dec.9
            </p>
          </div>
          <div>
            <p>
              Aws and american family insurance partner to take insurance to the
              cloud. Dec 5
            </p>
          </div>
          <div>
            <p>
              Amazon Announces a biggest holiday shopping weekend ever. Dec.2
            </p>
          </div>
          <div>
            <p>
              Amazon Book editor announces 2022's best book of the year. Nov.22
            </p>
          </div>
          <div>
            AWS duke energy Partner to develop smart grid solutions Nov.22
          </div>
        </div>
      </div>
      <div className="img-stories">
        <img
          src="https://assets.aboutamazon.com/dims4/default/4b91074/2147483647/strip/true/crop/1126x1126+437+0/resize/605x605!/format/webp/quality/90/?url=https%3A%2F%2Famazon-blogs-brightspot.s3.amazonaws.com%2F6a%2Fc9%2F9678ae054de0adaf1856f4fd7684%2Fblackfriday-hero-2000x1126.jpg"
          alt=""
          className="package-img"
        />
        <div className="stories">
          <h4>Top Stories</h4>
          <div>
            <img
              src="https://assets.aboutamazon.com/dims4/default/3702c5c/2147483647/strip/true/crop/480x270+0+45/resize/1320x743!/format/webp/quality/90/?url=https%3A%2F%2Fi.ytimg.com%2Fvi%2FtQPAWiVrfYA%2Fhqdefault.jpg"
              alt=""
            />
            <Link>
              Amazon games and bandai namco online team up for the release of
              blue protocol in 2023
            </Link>
          </div>
          <div>
            <img
              src="https://assets.aboutamazon.com/dims4/default/a007e0d/2147483647/strip/true/crop/1698x956+1+0/resize/1320x743!/format/webp/quality/90/?url=https%3A%2F%2Famazon-blogs-brightspot.s3.amazonaws.com%2F9e%2F54%2F6b05eb1c4c1eae29723817caed43%2Famazon-kindle-unlimited-new-books.jpg"
              alt=""
            />
            <Link>
              All the best new Books available at Kindle Unlimited members.
            </Link>
          </div>
          <div>
            <img
              src="https://assets.aboutamazon.com/dims4/default/f0c0ad8/2147483647/strip/true/crop/1919x1080+1+0/resize/1320x743!/format/webp/quality/90/?url=https%3A%2F%2Famazon-blogs-brightspot.s3.amazonaws.com%2F52%2Fdb%2Fbe526695488f9930577b4f8b0b67%2Freport-hero.jpg"
              alt=""
            />
            <Link>
              How amazon support our communities from education t affordable
              Housing.
            </Link>
          </div>
          <div>
            <img
              src="https://assets.aboutamazon.com/dims4/default/38b5d40/2147483647/strip/true/crop/1599x900+1+0/resize/1320x743!/format/webp/quality/90/?url=https%3A%2F%2Famazon-blogs-brightspot.s3.amazonaws.com%2Fc7%2F53%2F9999111a4428bd8e813cecf8d633%2Fdevice-avatar-inline.jpg"
              alt=""
            />
            <Link>What are the newest alexa features.</Link>
          </div>
          <div>
            <Link>See all stories</Link>
          </div>
        </div>
      </div>
      <div className="about-content">
        <div className="img-career">
          <img
            src="https://assets.aboutamazon.com/dims4/default/2773d8d/2147483647/strip/true/crop/743x743+100+0/resize/605x605!/format/webp/quality/90/?url=https%3A%2F%2Famazon-blogs-brightspot.s3.amazonaws.com%2Fd2%2Faf%2F5fa372b8442c80e06e9a2feefabb%2Femployees-operations-center1.jpg"
            alt=""
          />
          <Link className="dec-none link-text">
            Watch: Amazon employees discuss how they grow their careers and pay
          </Link>
          <div className="career-text">
            <Link className="black dec-none">
              <b>Read more</b>
            </Link>
            <p className="grey size-14">September 26 2022</p>
          </div>
        </div>
        <div className="img-career">
          <img
            src="https://assets.aboutamazon.com/dims4/default/3f1d947/2147483647/strip/true/crop/480x270+0+45/resize/1320x743!/format/webp/quality/90/?url=https%3A%2F%2Fi.ytimg.com%2Fvi%2FmvPfVBRhKFs%2Fhqdefault.jpg"
            alt=""
          />
          <Link className="dec-none link-text">
            Get all the latest news, deals, and updates from Amazon this holiday
            season
          </Link>
          <div className="career-text">
            <Link className="black dec-none">
              <b>Read more</b>
            </Link>
            <p className="grey">September 16 2022</p>
          </div>
        </div>
        <div className="amazon-news">
          <div className="width-div">
            <h1 className="orange">Amazon News</h1>
            <div className="size-20">
              Sign up for the latest news, facts, analysis, and original stories
              about Amazon delivered to you.
            </div>
            <input
              type="text"
              placeholder="Enter Email"
              className="news-letter-input"
            />
            <i className="submit fa fa-arrow-right"></i>
            <div className="news-text">
              <p>
                Provided by re Captcha. The Google
                <Link className="text-link"> Privacy Policy </Link>
                and terms of service apply.
                <Link className="text-link">Privacy Policy</Link> | Opt any
                time.
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="about-content">
        <div className="img-career small-img">
          <img
            src="https://assets.aboutamazon.com/dims4/default/3192ec8/2147483647/strip/true/crop/900x900+350+0/resize/605x605!/format/webp/quality/90/?url=https%3A%2F%2Famazon-blogs-brightspot.s3.amazonaws.com%2F6b%2F3d%2Fc3bde2fa464cb1dfc1009827b9f0%2Fholiday-inline-2.jpg"
            alt=""
          />
          <Link className="dec-none link-text">
            Academy Award winner Taika Waititi directs Amazon’s new holiday
            campaign, and it is 150 seconds of pure joy
          </Link>
          <div className="career-text">
            <Link className="black dec-none">
              <b>Read more</b>
            </Link>
            <p className="grey size-14">October 8 2022</p>
          </div>
        </div>
        <div className="img-career small-img">
          <img
            src="https://assets.aboutamazon.com/dims4/default/49d4288/2147483647/strip/true/crop/743x743+289+0/resize/605x605!/format/webp/quality/90/?url=https%3A%2F%2Famazon-blogs-brightspot.s3.amazonaws.com%2F40%2Ff0%2F9e34eecf4c7ea28dacabc536374d%2Fadam-selipsky-reinvent-22.jpg"
            alt=""
          />
          <Link className="dec-none link-text">
            'Alexa, thank my driver': Here’s the simple way Amazon customers can
            show delivery drivers appreciation this holiday season
          </Link>
          <div className="career-text">
            <Link className="black dec-none">
              <b>Read more</b>
            </Link>
            <p className="grey">December 11 2022</p>
          </div>
        </div>
        <div className="img-career small-img">
          <img
            src="https://assets.aboutamazon.com/dims4/default/153c989/2147483647/strip/true/crop/1000x1000+288+0/resize/605x605!/format/webp/quality/90/?url=https%3A%2F%2Famazon-blogs-brightspot.s3.amazonaws.com%2F59%2F15%2F855068b14fafb458857a4c02da83%2Falexathankmydriver-inline4-1600x900.jpg"
            alt=""
          />
          <Link className="dec-none link-text">
            AWS re:Invent 2022: All the highlights and key announcements from
            this year's cloud computing conference
          </Link>
          <div className="career-text">
            <Link className="black dec-none">
              <b>Read more</b>
            </Link>
            <p className="grey size-14">December 4 2022</p>
          </div>
        </div>
        <div className="img-career small-img">
          <img
            src="https://assets.aboutamazon.com/dims4/default/2708167/2147483647/strip/true/crop/1080x1080+420+0/resize/605x605!/format/webp/quality/90/?url=https%3A%2F%2Famazon-blogs-brightspot.s3.amazonaws.com%2F38%2F40%2F408175d64306aefe7141db6c56c2%2Fcohen-hero.jpg"
            alt=""
          />
          <Link className="dec-none link-text">
            Andy Cohen shares 3 ways he uses his Amazon devices and Alexa to
            hack the holiday season
          </Link>
          <div className="career-text">
            <Link className="black dec-none">
              <b>Read more</b>
            </Link>
            <p className="grey size-14">November 14 2022</p>
          </div>
        </div>
      </div>
      <div className="app-video">
        <h1>Install Our App</h1>
        <video src={appvideo} controls className="video-guide" autoplay></video>
      </div>
    </div>
  );
}
export default About;
